import React, { useState } from "react";
import { Row, Col, Card, Dropdown } from "react-bootstrap";
import ProjectCard from "../../components/projects/ProjectCard";
import EditGridModal from "../../components/modals/projects/EditGridModal";
import DeleteGridModal from "../../components/modals/projects/DeleteGridModal";
import ProjectHeader from "../../components/projects/ProjectHeader";
import { useProjects } from "../../components/context/ProjectContext";

const ProjectsGrid = () => {
  const { projects, deleteProject } = useProjects();
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const handleEdit = (project) => {
    setSelectedProject(project);
    setShowEdit(true);
  };

  const handleDelete = (project) => {
    setSelectedProject(project);
    setShowDelete(true);
  };

  const handleConfirmDelete = () => {
    if (selectedProject) {
      deleteProject(selectedProject.id);
      setShowDelete(false);
      setSelectedProject(null);
    }
  };

  return (
    <>
      <div style={{ background: "#f8f9fa" }} className="h-100">
        <ProjectHeader />
        {/* Header */}
        <Card className="mb-3 mx-2">
          <Card.Body className="d-flex justify-content-between flex-wrap">
            <h5>Projects Grid</h5>

            <div className="d-flex gap-2">
              <Dropdown>
                <Dropdown.Toggle
                  size="sm"
                  className="p-2 border border-1"
                  variant="light"
                >
                  Select Status
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>Active</Dropdown.Item>
                  <Dropdown.Item>Inactive</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <Dropdown>
                <Dropdown.Toggle
                  className="p-2 border border-1"
                  size="sm"
                  variant="light"
                >
                  Sort By : Last 7 Days
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>Recently Added</Dropdown.Item>
                  <Dropdown.Item>Ascending</Dropdown.Item>
                  <Dropdown.Item>Descending</Dropdown.Item>
                  <Dropdown.Item>Lat Month</Dropdown.Item>
                  <Dropdown.Item>Last 7 days</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Card.Body>
        </Card>

        {/* Grid */}
        <Row className="g-3 mx-0">
          {projects
            .filter((project) => project && project.title)
            .map((project, index) => (
              <Col xs={12} sm={6} md={3} lg={3} xl={3} key={index}>
                <ProjectCard
                  project={project}
                  onEdit={() => handleEdit(project)}
                  onDelete={() => handleDelete(project)}
                />
              </Col>
            ))}
        </Row>

        {/* Modals */}
        <EditGridModal
          show={showEdit}
          handleClose={() => setShowEdit(false)}
          project={selectedProject}
        />

        <DeleteGridModal
          show={showDelete}
          handleClose={() => setShowDelete(false)}
          project={selectedProject}
          onConfirmDelete={handleConfirmDelete}
        />
      </div>
    </>
  );
};

export default ProjectsGrid;
